// ══════════════════════════════════════════════════════════════════
//  Feature-flag do Atendimento (WhatsApp) por workspace
// ══════════════════════════════════════════════════════════════════
//  Espelha useEmpresasEnabled: lê a mesma chave `workspace_features`.
//  Esconder o menu é só UX — quem barra de verdade é o authorize() do
//  backend (server/whatsapp.js), que checa a mesma flag.
// ══════════════════════════════════════════════════════════════════

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@hooks/useAuth';
import { getConfigValue } from '@app';

export const useWhatsAppEnabled = (): { enabled: boolean; loading: boolean } => {
  const { workspace } = useAuth();
  const workspaceId = workspace?.id || null;

  const query = useQuery({
    queryKey: ['config', 'workspaceFeatures', workspaceId || ''],
    queryFn: () => getConfigValue<{ whatsapp_enabled?: boolean }>(workspaceId || '', 'workspace_features'),
    enabled: !!workspaceId,
    staleTime: 10 * 60 * 1000,
  });

  return { enabled: query.data?.whatsapp_enabled === true, loading: query.isLoading };
};
